import React from 'react';

import Button from '@mui/material/Button';

import { CurrentUserResponse, ProjectInfo } from 'state/userSlice';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';

const walkmeButtonStylesBase = {
  color: 'var(--secondary-light-text)',
  backgroundColor: 'rgba(136, 184, 246, 0.20)', // mostly-transparent blue
  '.MuiButton-startIcon': {
    margin: 0,
    marginRight: '4px',
  },
  borderRadius: '2px',
  padding: 0,
  paddingRight: '8px',
  fontSize: '16px',
  fontWeight: '400',
  letterSpacing: 'normal',
  minWidth: '70px',
  height: '24px',
  lineHeight: '24px',
};

export function WalkmeHelpButton() {
  return (
    <Button
      title="Help"
      aria-label="Help"
      id="help-actions-menuControl"
      aria-hidden="true"
      target="_blank"
      sx={walkmeButtonStylesBase}
      startIcon={
        <FontAwesomeIcon
          name="circle-question"
          type="regular"
          sx={{ color: '#88B8F6' }}
        />
      }
      href="https://help.streetlightdata.com/s/contactsupport"
    >
      Help
    </Button>
  );
}

export function WalkmeWhatsNewButton() {
  return (
    <Button
      title="Help"
      aria-label="See what's new"
      id="whats-new-button"
      aria-hidden="true"
      target="_blank"
      sx={{
        ...walkmeButtonStylesBase,
        backgroundColor: 'color-mix(in hsl, var(--gold-col), #00000000 80%)', // mostly-transparent blue
      }}
      startIcon={<FontAwesomeIcon name="bullhorn" gold />}
      href="https://help.streetlightdata.com/"
    >
      See what’s new!
    </Button>
  );
}

class WalkmeService {
  isLocal = window.location.hostname.includes('localhost');

  get walkmeVariables() {
    // @ts-ignore Property 'WALKME_VARIABLES' does not exist on type 'Window & typeof globalThis'.
    return window.WALKME_VARIABLES;
  }

  set walkmeVariables(value) {
    // @ts-ignore Property 'WALKME_VARIABLES' does not exist on type 'Window & typeof globalThis'.
    window.WALKME_VARIABLES = value;
  }

  resetWalkmeVariables() {
    if (!this.isLocal) {
      this.walkmeVariables = {};
    }
  }

  addWalkmeVariables(currentUser: CurrentUserResponse) {
    if (!this.isLocal) {
      this.walkmeVariables = {
        email: currentUser.email,
        user_id: currentUser.username,
        user_name: currentUser.email,
        actual_user_id: currentUser.username,
        effective_user_id: currentUser.username,
        actual_user_email: currentUser.email,
        effective_email_address: currentUser.email,
        is_emulating: false,
        url_subdomain: window.location.hostname.split('.')[0],
      };
    }
  }
  setProjectVariables(project_info: ProjectInfo) {
    if (project_info && !this.isLocal) {
      this.walkmeVariables = {
        ...this.walkmeVariables,
        org_id: project_info.org_id,
        org_name: project_info.org_name,
      };
    }
  }
}

export const walkmeService = new WalkmeService();
